module.exports = __webpack_public_path__ + "img/taxNoAct.ac3c863e.png";